import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Top3: FC<IconSvgProps> = ({ clss, width = 25, height = 25, hideText }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12.1327" cy="12.1327" r="11.6327" fill="url(#paint0_linear_top3)" stroke="url(#paint1_linear_top3)" />
            {!hideText && (
                <path
                    d="M11.1331 10.2455H9.76109C9.80309 9.48949 10.1251 8.84549 10.5591 8.42549C11.2031 7.80949 11.9871 7.71149 12.6031 7.71149C13.3171 7.71149 14.0171 7.85149 14.6191 8.48149C15.1091 8.98549 15.2911 9.58749 15.2911 10.2595C15.2911 10.7075 15.2071 11.0995 14.9691 11.4915C14.7171 11.8975 14.3951 12.1355 14.1291 12.2755C14.6051 12.4575 14.8991 12.7795 15.0531 13.0175C15.3191 13.4095 15.4451 13.9275 15.4451 14.4595C15.4451 15.3835 15.0951 16.0975 14.6471 16.5455C13.9751 17.2175 13.0931 17.3575 12.3651 17.3575C11.6511 17.3575 10.8811 17.2175 10.2791 16.5735C9.85909 16.1255 9.55109 15.3835 9.48109 14.6695H10.8531C10.9231 15.0895 11.1191 15.4535 11.3571 15.6775C11.5531 15.8595 11.9031 16.0975 12.4911 16.0975C12.9251 16.0975 13.3311 15.9295 13.5831 15.7055C13.8491 15.4535 14.0731 15.0195 14.0731 14.3895C14.0731 14.0815 14.0171 13.6335 13.6531 13.2835C13.2471 12.8915 12.7431 12.8635 12.4491 12.8635H12.1691V11.6595H12.3651C12.9671 11.6595 13.3451 11.4635 13.5551 11.2535C13.7791 11.0295 13.9191 10.6795 13.9191 10.2595C13.9191 9.76949 13.7091 9.47549 13.5551 9.32149C13.2331 9.01349 12.8411 8.97149 12.5611 8.97149C12.2251 8.97149 11.8331 9.02749 11.5251 9.34949C11.2031 9.68549 11.1331 10.1895 11.1331 10.2455Z"
                    fill="white"
                    fillOpacity="0.3"
                />
            )}
            <defs>
                <linearGradient id="paint0_linear_top3" x1="12.1327" y1="3.65668" x2="33.2572" y2="16.506" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D07900" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint1_linear_top3" x1="24.2336" y1="28.5898" x2="1" y2="-0.694114" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D07900" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default Top3;
